export default __webpack_public_path__ + "static/media/Hund-mit-Luftballon.00bc2d56.png";